import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider, useSelector} from 'react-redux';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {RootState, store} from './store';

import './index.css';
import './styles/modal-theme.css';

import App from './App';
import Register from './pages/Register'; // 👈 à créer
import reportWebVitals from './reportWebVitals';
import {ThemeProvider} from '@gravity-ui/uikit';
import NewPassword from "./components/NewPassword";

const ThemedRoot = () => {
    const theme = useSelector((state: RootState) => state.theme.value);

    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<App/>}/>
                    <Route path="/register" element={<Register/>}/>
                    <Route path="/users/forgotPassword" element={<NewPassword/>}/>
                </Routes>
            </BrowserRouter>
        </ThemeProvider>
    );
};

const RootComponent = () => {
    return (
        <Provider store={store}>
            <ThemedRoot/>
        </Provider>
    );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<RootComponent/>);

reportWebVitals();
